import '../../../assets/compact.svg.mjs';
import CompactIcon__default from "../../../../../assets/compact2.svg";
"use strict";
const compact = {
  id: "compact",
  title: "compact.title",
  icon: {
    src: CompactIcon__default,
    width: 47,
    height: 40
  }
};
export { compact };
//# sourceMappingURL=Compact.mjs.map
